import { Mask } from '../mask.interface';
export class AddressCepModel implements Mask {

private AddressCepMask = [/[0-9]/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];

  getMaskRule(): (string | RegExp)[] | Function | boolean {
    return this.AddressCepMask;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/input/rules/implementations/addressCep.model.ts